// Исключения по отчётам. Отсутствие записи = поведение по умолчанию.
// Чтобы отменить исключение — удалить строку.
interface KbkBehavior {
    checkboxHidden?: boolean          // чек-боксы разрезности расходов скрыты
    incomeCheckboxHidden?: boolean    // чек-боксы разрезности доходов скрыты
    draggingDisabled?: boolean        // перетаскивание строк расходов запрещено
    incomeDraggingDisabled?: boolean  // перетаскивание строк доходов запрещено
    spfMultiselectDisabled?: boolean  // список СПФ заблокирован
    pprNoneOption?: boolean           // в списке БПП первой строкой «0 — Без подпрограммы»
    abpCheckboxDisabled?: boolean     // чек-бокс уровня АБП заблокирован
}

export const kbkBehaviorConfig: Record<string, KbkBehavior> = {
    '4-20': { draggingDisabled: true, spfMultiselectDisabled: true, abpCheckboxDisabled: true },
    'DKI-R': { draggingDisabled: true },
    'MBSP': { checkboxHidden: true, draggingDisabled: true, incomeCheckboxHidden: true, incomeDraggingDisabled: true },
    'KF219-CO': { incomeDraggingDisabled: true },
}
